module.exports = "/_next/static/images/bounty-accept-branded-content-9d0ddf4e11469081189cc773c4831d7a.png";